import { Component, Children } from 'react';
import { connect } from 'react-redux';
import isFeatureFlagReady from '../../selectors/isFeatureFlagReady';
import { loadFeatureFlags } from '../../state/featureFlags/actions';

class FeatureFlagProvider extends Component {
  componentDidMount() {
    this.props.loadFeatureFlags();
  }

  render() {
    const { isReady } = this.props;

    if (isReady) {
      return Children.only(this.props.children);
    }
    return null;
  }
}

const mapStateToProps = state => {
  return {
    isReady: isFeatureFlagReady(state),
  };
};

const mapDispatchToProps = {
  loadFeatureFlags,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FeatureFlagProvider);
